import audienceListsPage from "./audienceListsPage.json";
import createAudienceListPage from "./createAudienceListPage.json";
import viewAudienceListPage from "./viewAudienceListPage.json";
import memberSummary from "./memberSummary.json";
import customerGroupSelector from "./customerGroupSelector.json";
import csvImportSection from "./csvImportSection.json";
import columnMappingModal from "./columnMappingModal.json";
import addAudienceListForm from "./addAudienceListForm.json";
import campaignsPage from "./campaignsPage.json";
import createCampaignPage from "./createCampaignPage.json";
import campaignDetailsPage from "./campaignDetailsPage.json";
import deliveryLogTable from "./deliveryLogTable.json";
import tagPanel from "./tagPanel.json";
import smsContentEditor from "./smsContentEditor.json";
import fileAttachmentManager from "./fileAttachmentManager.json";
import contentPreviewModal from "./contentPreviewModal.json";
import marketingSettingsPage from "./marketingSettingsPage.json";
import emailProviderForm from "./emailProviderForm.json";
import smsProviderForm from "./smsProviderForm.json";

// Marketing keeps one JSON per screen; each language's marketing/index.ts
// barrel assembles them into a single `marketing` namespace.
const marketing = {
  audienceListsPage,
  createAudienceListPage,
  viewAudienceListPage,
  memberSummary,
  customerGroupSelector,
  csvImportSection,
  columnMappingModal,
  addAudienceListForm,
  campaignsPage,
  createCampaignPage,
  campaignDetailsPage,
  deliveryLogTable,
  tagPanel,
  smsContentEditor,
  fileAttachmentManager,
  contentPreviewModal,
  marketingSettingsPage,
  emailProviderForm,
  smsProviderForm,
};

export default marketing;
